import { Component } from '@angular/core';

@Component({
  selector: 'app-header-spinner',
  templateUrl: './header-spinner.component.html',
  styleUrls: ['./header-spinner.component.css'],standalone:false
})
export class HeaderSpinnerComponent {

}
